import { colors } from '@mui/material'
import { AuctionStatus } from '@xyo-network/sdk-xyoworld-js'

const colorFromAuctionStatus = (status?: AuctionStatus) => {
  switch (status) {
    case AuctionStatus.Upcoming:
      return colors.grey[500]
    case AuctionStatus.Live:
      return colors.green[100]
    case AuctionStatus.Dutch:
      return colors.orange[100]
    case AuctionStatus.Completed:
      return colors.yellow[100]
    case AuctionStatus.Minted:
      return colors.grey[50]
    default:
      return '#fff'
  }
}

export default colorFromAuctionStatus
